export const RESET_PASSWORD_LOAD_REQUESTED = 'RESET_PASSWORD_LOAD_REQUESTED';
export const RESET_PASSWORD_LOAD_SUCCEEDED = 'RESET_PASSWORD_LOAD_SUCCEEDED';
export const RESET_PASSWORD_LOAD_FAILED = 'RESET_PASSWORD_LOAD_FAILED';
export const RESET_PASSWORD_RESET_STATE = 'RESET_PASSWORD_RESET_STATE';
